import React from 'react';

import { FullWidthSpace, InfoWithLabel } from 'common/components';

import { useFormatMessage } from 'hooks';
import { useFolderDownloadSettingQuery } from 'hooks/folders/queries';

import { formatMDY } from 'utils/formatDate';

import Messages from 'i18n/messages/folder';

const booleanFormat = (value) => {
  if (value === true) return 'True';
  if (value === false) return 'False';

  return value;
};

const sizeFormat = (value) => {
  return value + 'bytes';
};

const metaFieldList = [
  { fieldName: 'ownerName', label: 'ownerName' },
  { fieldName: 'dateCreated', label: 'dateCreatedEdit', format: formatMDY },
  { fieldName: 'lastUpdated', label: 'lastUpdated', format: formatMDY },
  { fieldName: 'lastUpdatedBy', label: 'lastUpdatedByEdit' },
  { fieldName: 'editable', label: 'editableEdit', format: booleanFormat },
  { fieldName: 'shareable', label: 'shareableEdit', format: booleanFormat },
  { fieldName: 'dateShared', label: 'dateSharedEdit', format: formatMDY },
  {
    fieldName: 'specialPurpose',
    label: 'specialPurposeEdit',
    format: booleanFormat,
  },
  { fieldName: 'estSize', label: 'estSizeEdit', format: sizeFormat },
  { fieldName: 'lastDownload', label: 'lastDownloadEdit', format: formatMDY },
  { fieldName: 'lastSchedule', label: 'lastScheduleEdit', format: formatMDY },
];

const DownloadFolderMetadata = (props) => {
  const { folderId } = props;

  const messages = useFormatMessage(Messages);
  const { data: latestDownloadSetting } = useFolderDownloadSettingQuery({
    folderId,
    enabled: false, //* enabled in modal - not here
  });

  return latestDownloadSetting ? (
    <FullWidthSpace>
      {metaFieldList.map((field, index) => {
        const fieldValue = latestDownloadSetting?.[field?.fieldName];

        const formatValue = field?.format
          ? field?.format(fieldValue)
          : fieldValue;

        return (
          <InfoWithLabel
            key={index}
            label={messages[field?.label]}
            labelColProps={{ flex: '150px' }}
            labelAlign='right'
            info={formatValue}
          />
        );
      })}
    </FullWidthSpace>
  ) : null;
};

export default DownloadFolderMetadata;
